$(function() {
	$('#geocoder-my-location').on('click', function() {
		$('.mapboxgl-ctrl-geolocate').click();
	})
})
